<template>
    <el-card shadow="never">
        <div class="header">
            <el-breadcrumb class="breadcrumb" separator="/">
              <el-breadcrumb-item :to="{ path: '/' }">工作台</el-breadcrumb-item>
              <el-breadcrumb-item>问题答疑</el-breadcrumb-item>
            </el-breadcrumb>
            <el-button type="primary" class="editbtn" @click="add">新增</el-button>
        </div>
    </el-card>
    <el-card shadow="never" style="margin-top:20px">
        <el-table row-key="id" v-loading="baseData.loading" border :data="tableData.data" style="width: 100%;margin-top: 10px;">
          <el-table-column prop="id" label="ID" width="60"/>
          <el-table-column prop="title" label="标题"/>
          <el-table-column prop="addTime" label="时间" width="110"/>
          <el-table-column label="状态" width="80">
            <template #default="scope">
                <p v-if="scope.row.status == 1">正常</p>
                <p v-else>下架</p>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="180">
            <template #default="scope">
              <el-button size="small" @click="edit(scope.row.id)" type="primary">编辑</el-button>
              <el-popconfirm
                confirm-button-text="是"
                cancel-button-text="否"
                title="确定删除吗?"
                @confirm="del(scope.row.id)"
              >
                <template #reference>
                  <el-button size="small" type="danger">删除</el-button>
                </template>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
        
        <div class="pagestyle">
          <el-pagination
            v-model:current-page="searchForm.page"
            v-model:page-size="searchForm.limit"
            layout="sizes, prev, pager, next"
            :total="tableData.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </el-card>
  </template>
  <script lang="ts" setup>
  import { reactive, onMounted } from 'vue'
  import { ElMessage, ElLoading } from 'element-plus'
  import api from '@/api/index'
  import {useRouter} from 'vue-router'

  const router = useRouter()
  const searchForm:any = reactive({
    limit:10,
    page:1,
  })
  const baseData:any = reactive({
    loading:false,
    title:'',
  })
  const tableData:any = reactive({
    data:[],
    total:0,
  })
  const handleSizeChange = (val:number) => {
    searchForm.limit = val
    searchForm.page = 1
    getList()
  }
  const handleCurrentChange = (val:any) => {
    searchForm.page = val
    getList()
  }
  const getList = () => {
    localStorage.setItem('qapage',searchForm.page);
    localStorage.setItem('qalimit',searchForm.limit);
    baseData.loading = true
    api.qaApi.list(searchForm).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        tableData.data = res.data.list
        tableData.total = res.data.total
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const add = () => {
    router.push("/qa/add");
  }
  const edit = (id:any) => {
    router.push("/qa/edit/"+id);
  }
  const del = (id:number) => {
    baseData.loading = true
    api.qaApi.del({id:id}).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        ElMessage({
          message: res.message,
          type: 'success',
        })
        getList()
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  onMounted(() => {
    searchForm.page = localStorage.getItem('qapage')&&localStorage.getItem('qapage')!=null&&localStorage.getItem('qapage')!='null' ? parseInt(localStorage.getItem('qapage') ): 1;
    searchForm.limit = localStorage.getItem('qalimit')&&localStorage.getItem('qalimit')!=null&&localStorage.getItem('qalimit')!='null' ? parseInt(localStorage.getItem('qalimit')) : 10;
    getList()
  })
  </script>